export default {"src":"/_next/static/media/exclamation-bubble.acaebfaa.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};